import request from '@/utils/request'
const BASE_URL = '/MultiUnit'

export default {
  list(data) {
    return request({
      url: BASE_URL + '/List',
      method: 'post',
      data
    })
  },
  info(id) {
    return request({
      url: BASE_URL + '/Info',
      method: 'get',
      params: { id }
    })
  },
  save(data) {
    return request({
      url: BASE_URL + '/Save',
      method: 'post',
      data
    })
  },
  delete(data) {
    return request({
      url: BASE_URL + '/Delete',
      method: 'post',
      data
    })
  },
  getGoodsPrice(data) {
    return request({
      url: BASE_URL + '/GetGoodsPrice',
      method: 'post',
      data
    })
  },
  getPictures(id) {
    return request({
      url: BASE_URL + '/GetPictures',
      method: 'get',
      params: { id }
    })
  },
  uploadThumbnail: BASE_URL + '/UploadThumbnail', // 上传缩略图
  uploadPicture: BASE_URL + '/UploadPicture',
  deletePicture(picId) {
    
    return request({
      url: BASE_URL + '/DeletePicture',
      method: 'get',
      params: { picId }
    })
  },
  uploadMP4: BASE_URL + '/UploadMP4',
}